import { useEffect } from 'react';
import Hotjar from '@hotjar/browser';

// Hotjar configuration constants
const siteId = 6392147;
const hotjarVersion = 6;

// Custom logger that only logs in development mode
const logger = {
  log: (message: string, ...args: any[]) => {
    if (import.meta.env.DEV) {
      console.log(message, ...args);
    }
  },
  error: (message: string, ...args: any[]) => {
    if (import.meta.env.DEV) {
      console.error(message, ...args);
    }
  }
};

// Utility function to track custom events in Hotjar
export const trackHotjarEvent = (eventName: string, eventValue?: any) => {
  try {
    if (typeof window !== 'undefined' && Hotjar.isReady()) {
      Hotjar.event(eventName);
      logger.log(`Hotjar event tracked: ${eventName}`);
    }
  } catch (error) {
    logger.error('Failed to track Hotjar event:', error);
  }
};

export const HotjarIntegration = () => {
  useEffect(() => {
    // Only initialize in browser environment and not during server-side rendering
    if (typeof window !== 'undefined') {
      // Initialize Hotjar with provided site ID and version
      Hotjar.init(siteId, hotjarVersion);
      logger.log('Hotjar initialized');
    }
  }, []);

  // This is a utility component that doesn't render anything
  return null;
}; 